module.exports = __webpack_public_path__ + "img/O4.84c036da.png";